import React from 'react';
import classNames from 'classnames';

export interface DividerProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  variant?: 'full' | 'middle' | 'inset';
  color?: string;
}

const Divider: React.FC<DividerProps> = ({
  className = '',
  orientation = 'horizontal',
  variant = 'full',
  color = 'bg-gray-200 dark:bg-gray-700',
}) => {
  const dividerClasses = classNames(
    color,
    {
      'w-full h-px': orientation === 'horizontal',
      'h-full w-px': orientation === 'vertical',
      'mx-0': variant === 'full' && orientation === 'horizontal',
      'my-0': variant === 'full' && orientation === 'vertical',
      'mx-4': variant === 'middle' && orientation === 'horizontal',
      'my-4': variant === 'middle' && orientation === 'vertical',
      'ml-4': variant === 'inset' && orientation === 'horizontal',
      'mt-4': variant === 'inset' && orientation === 'vertical',
    },
    className
  );

  return <div className={dividerClasses} />;
};

export default Divider;